import CertificateService from "../services/certificate.service";

const state = {
	certificates: [],
	editList:[],
	certificateForPos: null,
	certificateError: false,
	certificateLoading: false
};

const getters = {
	getCertificates: (state) => {
		return state.certificates;
	},
	getEditCertificate(state){
		return state.editList
	}
};


const actions = {
	async generateCertificate({commit},data){
		try {
			const certificates = await CertificateService.generateCertificate(data)
			return true
		} catch (e) {
			return false
		}
	},
	async getCertificateByNumber({commit},certificateNumber){
		try {
			const response = await CertificateService.getCertificateByNum(certificateNumber)
			commit('setCertificateForPos', response.data);
			commit('setCertificateLoading', false);
			return true
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('posCertificateError', {message: response.message, boolean: true});
			commit('setCertificateLoading', false);
			return false;
		}
	},
	async getEditCertificateList({commit},data){
		try {
			const certificates = await CertificateService.getEditCertificate(data)
			commit('setEditCertificate', certificates.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getCertificateList({commit},data){
		try {
			const certificates = await CertificateService.getCertList(data)
			commit('setGenerateCertificate', certificates.data);
			return true
		} catch (e) {
			return false
		}
	},
};

const mutations = {
	setGenerateCertificate(state, certificates){
		state.certificates = certificates;
	},
	setCertificateForPos(state, certificate){
		state.certificateForPos = certificate;
		state.certificateError = false;
	},
	resetCertificateForPos(state){
		state.certificateForPos = null;
	},
	posCertificateError(state, obj){
		state.certificateError = obj.message;
		state.certificateForPos = null;
	},
	setCertificateLoading(state, boolean){
		state.certificateLoading = boolean;
	},
	setEditCertificate(state,certificates){
		state.editList = certificates;
	}
};

export const certificates = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}

